import { render } from "./moduleIconEnat.vue?vue&type=template&id=50e031a5&scoped=true"
import script from "./moduleIconEnat.vue?vue&type=script&lang=js"
export * from "./moduleIconEnat.vue?vue&type=script&lang=js"

import "./moduleIconEnat.vue?vue&type=style&index=0&id=50e031a5&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\horva\\Documents\\nodejs\\production\\enat05\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50e031a5"]])

export default __exports__